import 'css-chunk:../authentication/frontend/components/index.module.scss';export default {
  "faded": "_faded_1he0s_1",
  "height": "_height_1he0s_8",
  "shake": "_shake_1he0s_12"
};